import React, { useState, useRef, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import '../../styles/custom.css';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEldData } from '../../redux/thunk/thunk';
import { dictionary } from '../../dictionary';
import MobileOverlay from '../common/MobileOverlay';
import { getUserColors } from '../tables/utils/utils';

const Login = () => {
  const dispatch = useDispatch();
  const eldData = useSelector((state) => state.fetch.data);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchEldData());
  }, [dispatch]);

  useEffect(() => {
    if (eldData !== null) {
      setUsers(eldData[0].users);
    }
  }, [eldData]);

  const addSuccessMsg = (user) => {
    toast.current.show({
      severity: 'success',
      summary: dictionary.toast_summary_success,
      detail: dictionary.toast_login_detail + user.name,
    });
  };

  const handleSubmit = async (user) => {
    setLoading(true);
    sessionStorage.setItem('isLoggedIn', true);
    sessionStorage.setItem('userName', user.name);
    sessionStorage.setItem('user', JSON.stringify(user));

    addSuccessMsg(user);
    setTimeout(() => {
      setLoading(false);
      navigate('/timesheet', { replace: true });
    }, 2000);
  };

  return (
    <>
      <MobileOverlay />
      {eldData ? (
        <Dialog
          header={dictionary.login_title}
          style={{ width: '100vw' }}
          visible={visible}
          onHide={() => {
            setVisible(false);
            navigate('/home');
          }}
          className="user-selection-dialog"
        >
          {loading && (
            <div className="loading-wrapper">
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="2" animationDuration="3s" />
            </div>
          )}
          <Toast ref={toast} />
          <div className="search-container">
            <InputText
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={dictionary.login_search_placeholder}
              className="search-input"
            />
          </div>

          <div className="user-bento-grid">
            {users
              .filter((obj) => obj.available !== false)
              .filter((obj) => obj.name.toLowerCase().includes(searchTerm.toLowerCase()))
              .map((obj, i) => {
                const colors = getUserColors(obj.name);
                return (
                  <div
                    key={i}
                    className="user-bento-card"
                    style={{ backgroundColor: colors.light }}
                    onClick={() => handleSubmit(obj)}
                  >
                    <div className="avatar-circle" style={{ backgroundColor: colors.dark }}>
                      {obj.name
                        .split(' ')
                        .map((n) => n[0])
                        .join('')
                        .toUpperCase()
                        .substring(0, 2)}
                    </div>
                    <span className="user-name-label">{obj.name}</span>
                  </div>
                );
              })}
          </div>
        </Dialog>
      ) : (
        <div className="loading-wrapper">
          <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="2" animationDuration="3s" />
        </div>
      )}
    </>
  );
};

export default Login;
